import { notify, confirm } from '../../utils/notify';
import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { vendorAPI } from '../../services/api';
import { useListControls, ListToolbar, Pagination } from '../../components/ListControls';
import Topbar from "../../components/Topbar";

function VendorInvoiceUpload() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({invoiceNumber:'',invoiceDate:'',invoiceAmount:''});
  const [saving, setSaving] = useState(false);
  

  const load = () => {
    setLoading(true);
    vendorAPI.listPaymentRequests().then(d=>{
      setRequests((d.requests||[]).filter(r=>['PENDING_L1','PENDING_L2','PENDING_L3','PENDING_FINANCE','FINANCE_APPROVED'].includes(r.status)));
    }).catch(()=>{}).finally(()=>setLoading(false));
  };
  useEffect(()=>{ load(); },[]);

  const lc = useListControls(requests, { searchFields: [r=>r.vendorId?.name, 'paymentRequestCode', 'poNumber'], dateField: 'createdAt', pageSize: 10 });

  const handleUpload = async () => {
    if (!modal||!form.invoiceNumber) { notify.error('Invoice number is required'); return; }
    setSaving(true);
    try {
      await vendorAPI.uploadInvoice({ paymentRequestId:modal._id, ...form, invoiceAmount:Number(form.invoiceAmount) });
      notify.success('Invoice uploaded successfully!');
      setModal(null); setForm({invoiceNumber:'',invoiceDate:'',invoiceAmount:''}); load();
    } catch(e) { notify.error(e.message); } finally { setSaving(false); }
  };

  return (
    <>
      <Header/>
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Vendor Payment" /><section className="container-fluid p-4 pt-3">
        

        <div className="page-hero"><div><h5 className="text-white lh-1">Vendor Invoice Upload</h5><div className="sub">Step 4 — Upload invoice, bill copy, supporting documents and tax invoice</div></div></div>

        {loading?<div className="text-center py-5"><span className="spinner-border text-primary"/></div>
        :requests.length===0?<div className="empty-state"><i className="bi bi-cloud-upload"/><p>No payment requests awaiting invoice upload</p></div>
        :(<>
        <ListToolbar search={lc.search} setSearch={lc.setSearch} dateFrom={lc.dateFrom} setDateFrom={lc.setDateFrom} dateTo={lc.dateTo} setDateTo={lc.setDateTo} placeholder="Search by vendor, code, PO..." dateLabel="Created"/>
        {lc.paginated.map((r,idx)=>(
          <div key={r._id} className="record-card">
            <div className="record-number">{(lc.page-1)*lc.pageSize+idx+1}.</div>
            <div className="record-body">
              <div className="d-flex align-items-center gap-2 mb-1">
                <div style={{fontWeight:700,fontSize:'0.874rem',color:'#111827'}}>{r.vendorId?.name||'—'}</div>
                <span className="status-pill status-pending"><i className="bi bi-hourglass"/>{r.status}</span>
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-4">
                  <div className="record-field"><span className="rf-label">Request Code — </span><span className="rf-value text-primary">{r.paymentRequestCode}</span></div>
                  <div className="record-field"><span className="rf-label">Project — </span><span className="rf-value">{r.projectId?.projectCode}</span></div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="record-field"><span className="rf-label">PO Number — </span><span className="rf-value">{r.poNumber||'—'}</span></div>
                  <div className="record-field"><span className="rf-label">Amount — </span><span className="rf-value fw-bold">{new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(r.requestedAmount)}</span></div>
                </div>
              </div>
            </div>
            <div className="divider d-none d-md-block"/>
            <div className="record-actions">
              <button className="btn-card-view" onClick={()=>setModal(r)}><i className="bi bi-cloud-upload me-1"/>Upload Invoice</button>
            </div>
          </div>
        ))}
        <Pagination page={lc.page} totalPages={lc.totalPages} setPage={lc.setPage} totalCount={lc.totalCount} pageSize={lc.pageSize} itemLabel="requests"/>
        </>)}

        {modal&&(
          <div className="modal show d-block" style={{background:'rgba(0,0,0,0.45)'}}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow-lg">
                <div className="modal-header border-0"><h5 className="fw-bold"><i className="bi bi-cloud-upload me-2"/>Upload Invoice — {modal.paymentRequestCode}</h5><button className="btn-close" onClick={()=>setModal(null)}/></div>
                <div className="modal-body">
                  <div style={{padding:'7px 10px',background:'#eff6ff',borderRadius:8,marginBottom:8,fontSize:'0.736rem',color:'#1d4ed8'}}>
                    Vendor: <b>{modal.vendorId?.name}</b> | Amount: <b>{new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(modal.requestedAmount)}</b>
                  </div>
                  <div className="row g-2">
                    <div className="col-12"><label className="form-label small fw-semibold">Invoice Number *</label><input className="form-control" value={form.invoiceNumber} onChange={e=>setForm(p=>({...p,invoiceNumber:e.target.value}))} placeholder="INV-2025-001"/></div>
                    <div className="col-md-6"><label className="form-label small fw-semibold">Invoice Date</label><input type="date" className="form-control" value={form.invoiceDate} onChange={e=>setForm(p=>({...p,invoiceDate:e.target.value}))}/></div>
                    <div className="col-md-6"><label className="form-label small fw-semibold">Invoice Amount (₹)</label><input type="number" className="form-control" value={form.invoiceAmount} onChange={e=>setForm(p=>({...p,invoiceAmount:e.target.value}))}/></div>
                    <div className="col-12">
                      <div style={{padding:'8px 10px',background:'#f9fafb',borderRadius:8,border:'2px dashed #e5e7eb',textAlign:'center',fontSize:'0.754rem',color:'#9ca3af'}}>
                        <i className="bi bi-cloud-upload" style={{fontSize:24,display:'block',marginBottom:6}}/>
                        File upload via S3 presigned URL — attach invoice documents here<br/>
                        <span style={{fontSize:'0.7rem'}}>(PDF, JPG, PNG supported)</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 gap-2">
                  <button className="btn btn-light rounded-3 px-4" onClick={()=>setModal(null)}>Cancel</button>
                  <button className="btn rounded-3 px-5 fw-semibold" style={{background:'linear-gradient(135deg,#1a5276,#1e8449)',color:'#fff',border:'none'}} onClick={handleUpload} disabled={saving}>
                    {saving?<span className="spinner-border spinner-border-sm"/>:<><i className="bi bi-cloud-upload me-1"/>Upload Invoice</>}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </section></main></div>
    </>
  );
}
export default VendorInvoiceUpload;
